var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBalancedlife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#fefeff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 64,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M17.568,20.372c-5.053,0-9.164-4.57-9.164-10.186S12.515,0,17.568,0s9.164,4.57,9.164,10.186S22.62,20.372,17.568,20.372m0-16.3c-3.032,0-5.5,2.741-5.5,6.112s2.466,6.112,5.5,6.112,5.5-2.741,5.5-6.112-2.466-6.112-5.5-6.112",
    transform: "translate(-0.703 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M51.193,20.317c-4.295,0-7.789-3.884-7.789-8.658S46.9,3,51.193,3s7.789,3.884,7.789,8.658-3.494,8.658-7.789,8.658m0-13.242a4.377,4.377,0,0,0-4.124,4.584,4.147,4.147,0,1,0,8.247,0,4.377,4.377,0,0,0-4.124-4.584",
    transform: "translate(-3.631 0.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M36.508,57.2a2.006,2.006,0,0,0-1.583-2.282l-.165-.026-.165.026A2.006,2.006,0,0,0,33.014,57.2a1.747,1.747,0,1,0,3.494,0",
    transform: "translate(-2.76 1.022)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M63.4,29.168C60.278,18.752,51.995,16,48.052,16c-7.587,0-12.061,3.41-14.489,6.266a6.883,6.883,0,0,0-1.426-.154,6.953,6.953,0,0,0-1.655.2C28.063,19.452,23.581,16,15.947,16,12,16,3.721,18.752.6,29.168A18.561,18.561,0,0,0,.836,39.309C2.494,45.5,8.709,56.38,31.694,59.686a1.568,1.568,0,0,0,.237.017c.024,0,.046-.006.069-.007a1.917,1.917,0,0,1-1.747-1.769,2.007,2.007,0,0,1,1.582-2.282L32,55.619C10.432,52.468,5.477,42.357,4.349,38.146a14.224,14.224,0,0,1-.276-7.689C7.127,20.277,15.6,20.079,15.947,20.074c5.585,0,9.058,2.165,11.1,4.194a8.967,8.967,0,0,0-2.606,6.4c0,4.717,3.453,8.555,7.7,8.555s7.7-3.838,7.7-8.555a8.949,8.949,0,0,0-2.74-6.537,15.139,15.139,0,0,1,10.95-4.058c.359,0,8.829.2,11.883,10.383a14.235,14.235,0,0,1-.277,7.689C58.523,42.357,53.567,52.468,32,55.619l.165.025a2.007,2.007,0,0,1,1.582,2.282A1.917,1.917,0,0,1,32,59.7c.023,0,.045.007.068.007a1.568,1.568,0,0,0,.237-.017C55.29,56.38,61.5,45.5,63.163,39.31A18.584,18.584,0,0,0,63.4,29.168M32.137,35.15A4.28,4.28,0,0,1,28.1,30.669a4.7,4.7,0,0,1,1.275-3.253,3.935,3.935,0,0,1,1.655-1.038,3.4,3.4,0,0,1,1.9-.1,3.852,3.852,0,0,1,1.773.97,4.659,4.659,0,0,1,1.461,3.424,4.28,4.28,0,0,1-4.032,4.481",
    transform: "translate(0 0.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M34.01,58.432c-7.159,0-11.607-3.778-11.607-9.859C22.4,42.2,27.474,34.8,34.01,34.8s11.607,7.4,11.607,13.773c0,6.081-4.448,9.859-11.607,9.859m0-19.558c-4.277,0-7.942,5.332-7.942,9.7,0,5.22,5.554,5.785,7.942,5.785s7.942-.564,7.942-5.785c0-4.366-3.665-9.7-7.942-9.7",
    transform: "translate(-1.874 0.648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBalancedlife);
export default __webpack_public_path__ + "static/media/icon_balancedlife.0257dada4fb8066f303a12c812e6b7de.svg";
export { ForwardRef as ReactComponent };